export default "__VITE_ASSET__BaurjRS4__"